<template>
  <!-- Content -->
  <!-- Detail Style 1 -->
  <div class="row col-md-12 m-0 mt-2 p-2" v-if="item_view">
    <div class="col-md-6 col-6 mb-3 px-1 pe-2">
      <p class="mb-2">Product Name</p>
      <span class="form-control disabled">
        {{ productInfo.product_name }}
      </span>
    </div>
    <div class="col-md-3 col-3 mb-3">
      <p class="mb-2 repeater-title">Product Code</p>
      <input type="text" 
        class="form-control invoice-item-price" 
        v-model="productInfo.product_code"
        disabled
      >
    </div>
    <div class="col-md-3 col-3"></div>

    <div class="col-md-3 col-3 px-1">
      <p class="mb-2 repeater-title">
        <span class="ma-1">Quantity In </span>
        <span class="float-end">
          Remain: {{ productInfo.quantity_in_stock >= 0 ? productInfo.quantity_in_stock : "over " + Math.abs(productInfo.quantity_in_stock) }} pieces
        </span>
      </p>
      <cleave class="form-control invoice-item-price mb-3 edit-input" 
        placeholder="100" style="text-align:right;"
        v-model="productInfo.quantity_in"
        :options="cleaveOptions.quantity_in"
      />
    </div>
    <div class="col-md-3 col-3">
      <p class="mb-2 repeater-title">Product Unit</p>
      <span type="text" class="form-control" style="background-color: #eceef1;">{{ getProductUnitName(productInfo.product_unit) }}&nbsp;</span>
    </div>
    <div class="col-md-3 col-3">
      <p class="mb-2 repeater-title">Quantity Out</p>
      <cleave class="form-control invoice-item-price mb-3 edit-input" 
        placeholder="100" 
        style="text-align:right;"
        v-model="productInfo.quantity_out"
        :options="cleaveOptions.quantity_out"
      />
      <!-- <div class="error-msg" v-if="stateData.error_lists.length > 0"> 
        {{ stateData.error_lists[0].message}}
      </div> -->
      <div class="error-msg" v-if="productError">
        {{ productError.message }}
      </div>
    </div>
    <div class="col-md-3 col-3 pe-1">
      <p class="mb-2 repeater-title">Product Unit</p>
      <span type="text" class="form-control"  style="background-color: #eceef1;">{{ getProductUnitName(productInfo.product_unit) }}&nbsp;</span>
    </div>
    <div class="col-md-3 col-3 px-1">
      <p class="mb-2 repeater-title">Buy Price</p>
      <div class="input-group mb-3">
        <span class="input-group-text px-2 disabled">{{ stateData.buy_currency }}</span>
        <span class="form-control px-1 disabled" 
          style="text-align:right;">
          {{ getFormatCurrency(productInfo.buy_price) }}
        </span>
      </div>
    </div>
    <div class="col-md-3 col-3">
      <p class="mb-2 repeater-title">Buy Price in VND</p>
      <div class="input-group">
        <span class="input-group-text px-2 disabled">VND</span>
        <span class="form-control px-1 disabled" 
          style="text-align:right;">
          {{ getFormatCurrency(productInfo.buy_price_vnd) }}
        </span>
      </div>
    </div>
    <div class="col-md-3 col-3">
      <p class="mb-2 repeater-title">Sell Price</p>
      <div class="input-group mb-3">
        <span class="input-group-text px-2 disabled">{{ stateData.sell_currency }}</span>
        <span class="form-control px-1 disabled" 
          style="text-align:right;">
          {{ getFormatCurrency(productInfo.sell_price) }}
        </span>
      </div>
    </div>
    <div class="col-md-3 col-3 pe-1">
      <p class="mb-2 repeater-title">Sell Price in VND</p>
      <div class="input-group">
        <span class="input-group-text px-2 disabled">VND</span>
        <span class="form-control px-1 disabled" 
          style="text-align:right;">
          {{ getFormatCurrency(productInfo.sell_price_vnd) }}
        </span>
      </div>
    </div>

    <div class="row col-md-6 col-6 px-2 pe-0">
      <p class="mb-2 repeater-title">Buy TAX</p>
      <div class="col-md-4 col-4 px-1 mx-1">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_1.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_1.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-1" style="margin-left: -0.5rem;">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_2.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_2.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-0">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_3.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_3.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
    </div>
    <div class="row col-md-6 col-6 px-0 pe-0" style="margin-left: 1.6rem;">
      <p class="mb-2 repeater-title">Sell TAX</p>
      <div class="col-md-4 col-4 px-1" style="margin-left: 4px;">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_1.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_1.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-1" style="margin-left: -0.3rem;">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_2.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_2.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-0">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_3.name"
            disabled
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-2 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_3.value"
            :options="cleaveOptions.tax"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
  <!-- / Detail Style 1 -->

  <!-- Detail Style 2 -->
  <!-- <div class="row col-md-12 m-0 mt-2 p-2" v-else>
    <div class="col-md-8 col-8 mb-1 px-1 pe-2">
      <span class="form-control disabled">
        {{ productInfo.product_name }}
      </span>
    </div>
    <div class="col-md-4 col-4 mb-1 px-1">
      <input type="text" 
        class="form-control invoice-item-price py-2" 
        style="margin-left: -0.5rem;"
        v-model="productInfo.product_code"
        disabled
      >
    </div>
    <div class="col-md-2 col-2 px-1">
      <div class="input-group mb-1">
        <span class="input-group-text px-1">{{ getProductUnitName(productInfo.product_unit) }}</span>
        <cleave class="form-control invoice-item-price px-1" 
          placeholder="Quantity-In" style="text-align:right;"
          v-model="productInfo.quantity_in"
          :options="cleaveOptions.quantity_in"
        />
      </div>
    </div>
    <div class="col-md-2 col-2 px-1">
      <div class="input-group mb-1">
        <span class="input-group-text px-1">{{ stateData.buy_currency }}</span>
        <cleave class="form-control px-1" 
          placeholder="Buy Price" 
          style="text-align:right;"
          v-model="productInfo.buy_price"
          :options="cleaveOptions.buy_price"
        />
      </div>
    </div>
    <div class="col-md-2 col-2 px-1">
      <div class="input-group">
        <span class="input-group-text px-1">VND</span>
        <cleave class="form-control px-1" 
          placeholder="Buy Price (VND)" 
          style="text-align:right;" 
          v-model="productInfo.buy_price_vnd"
          :options="cleaveOptions.buy_price"
          disabled
        />
      </div>
    </div>
    <div class="row col-md-6 col-6 px-2 pe-0">
      <div class="col-md-4 col-4 px-1 mx-1">
        <div class="input-group mb-1">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_1.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_1.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_buy_1.name"
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-1" style="margin-left: -0.5rem;">
        <div class="input-group mb-1">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_2.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_2.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_buy_2.name"
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-0">
        <div class="input-group mb-1">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_buy_3.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_buy_3.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_buy_3.name"
          />
        </div>
      </div>
    </div>
    <div class="col-md-2 col-2 px-1">
      <div class="input-group mb-1">
        <span class="input-group-text px-1">{{ getProductUnitName(productInfo.product_unit) }}</span>
        <cleave class="form-control invoice-item-price px-1" 
          placeholder="Quantity Out" 
          style="text-align:right;"
          v-model="productInfo.quantity_out"
          :options="cleaveOptions.quantity_out"
        />
      </div>
    </div>
    <div class="col-md-2 col-2 px-1">
      <div class="input-group mb-3">
        <span class="input-group-text px-1">{{ stateData.sell_currency }}</span>
        <cleave class="form-control px-1" 
          placeholder="Sell Price" 
          style="text-align:right;"
          v-model="productInfo.sell_price"
          :options="cleaveOptions.sell_price"
        />
      </div>
    </div>
    <div class="col-md-2 col-2 px-1 me-2">
      <div class="input-group">
        <span class="input-group-text px-1">VND</span>
        <cleave class="form-control px-1" 
          placeholder="999,999,999,000" 
          style="text-align:right;" 
          v-model="productInfo.sell_price_vnd"
          :options="cleaveOptions.sell_total_amount"
          disabled
        />
      </div>
    </div>
    <div class="row col-md-6 col-6 px-1">
      <div class="col-md-4 col-4 px-1">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_1.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_1.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_sell_1.name"
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-1" style="margin-left: -0.3rem;">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_2.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_2.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_sell_2.name"
          />
        </div>
      </div>
      <div class="col-md-4 col-4 px-0">
        <div class="input-group mb-3">
          <select
            class="form-select px-1" 
            name="select-tax"
            v-model="productInfo.tax_sell_3.name"
          >
            <option value="">EMPTY</option>
            <option 
              v-for="(ele, index) in taxOptions" 
              :key="index" 
              :value="ele.symbol"
            >
              {{ ele.symbol + " %"}}
            </option>
          </select>
          <cleave class="form-control px-1 me-0" 
            style="max-width: 3rem; text-align: right;"
            placeholder="0.0"
            v-model="productInfo.tax_sell_3.value"
            :options="cleaveOptions.tax"
            v-bind:disabled="!productInfo.tax_sell_3.name"
          />
        </div>
      </div>
    </div>
    <div class="error-msg" v-if="productError">
      {{ productError.message }}
    </div>
  </div> -->
  <!-- / Detail Style 2 -->
   
  <!-- Detail Style 2 – COMPACT -->
  <div class="row col-md-12 m-0 mt-2 p-1 shipment-item" v-else>

    <!-- HEADER -->
    <div class="col-12 d-flex mb-2">
      <div class="fw-semibold me-3">
        {{ productInfo.product_name }}
      </div>
      <div class="fw-semibold">
        ( {{ productInfo.product_code }} )
      </div>
    </div>

    <!-- BUY ROW -->
    <div class="col-12 shipment-row">
      <div class="row align-items-center g-2">
        <div class="col-1 row-label">IN</div>
        <!-- Quantity In -->
        <div class="col-2 input-wrap qty-field">
          <span class="input-unit-left">
            {{ getProductUnitName(productInfo.product_unit) }}
          </span>
          <cleave
            class="form-control form-soft edit-input"
            v-model="productInfo.quantity_in"
            :options="cleaveOptions.quantity_in"
          />
        </div>
        <!-- Buy Price -->
        <div class="col-3 input-wrap">
          <span class="input-unit-left">{{ stateData.buy_currency }}</span>
          <cleave
            class="form-control form-soft"
            v-model="productInfo.buy_price"
            :options="cleaveOptions.buy_price"
            disabled
          />
        </div>
        <!-- Buy Price VND -->
        <div class="col-3 position-relative">
          <span class="input-unit-left">VND</span>
          <cleave
            class="form-control form-soft"
            v-model="productInfo.buy_price_vnd"
            :options="cleaveOptions.buy_price"
            disabled
          />
        </div>
        <!-- TAX -->
        <div class="col-3 input-wrap d-flex align-items-end">
          <!-- TAX CHIPS (READONLY DISPLAY) -->
          <div class="tax-chip" v-if="productInfo.tax_buy_1.name">
            <span>{{ productInfo.tax_buy_1.name }}</span>: {{ productInfo.tax_buy_1.value }}%
          </div>
          <div class="tax-chip" v-if="productInfo.tax_buy_2.name">
            <span>{{ productInfo.tax_buy_2.name }}</span>: {{ productInfo.tax_buy_2.value }}%
          </div>
          <div class="tax-chip" v-if="productInfo.tax_buy_3.name">
            <span>{{ productInfo.tax_buy_3.name }}</span>: {{ productInfo.tax_buy_3.value }}%
          </div>
        </div>

      </div>
    </div>

    <!-- SELL ROW -->
    <div class="col-12 shipment-row">
      <div class="row align-items-center g-2">

        <div class="col-1 row-label">OUT</div>

        <!-- Quantity Out -->
        <div class="col-2 input-wrap qty-field">
          <span class="input-unit-left">
            {{ getProductUnitName(productInfo.product_unit) }}
          </span>
          <cleave
            class="form-control form-soft edit-input"
            v-model="productInfo.quantity_out"
            :options="cleaveOptions.quantity_out"
          />
        </div>

        <!-- Sell Price -->
        <div class="col-3 input-wrap">
          <span class="input-unit-left">{{ stateData.sell_currency }}</span>
          <cleave
            class="form-control form-soft"
            v-model="productInfo.sell_price"
            :options="cleaveOptions.sell_price"
            disabled
          />
        </div>
        <!-- Sell Price VND -->
         <div class="col-3 position-relative">
          <span class="input-unit-left">VND</span>
          <cleave
            class="form-control form-soft"
            v-model="productInfo.sell_price_vnd"
            :options="cleaveOptions.sell_total_amount"
            disabled
          />
        </div>
        <!-- TAX -->
        <div class="col-3 input-wrap d-flex align-items-end">
          <!-- TAX CHIPS -->
          <div class="tax-chip" v-if="productInfo.tax_sell_1.name">
            <span>{{ productInfo.tax_sell_1.name }}</span>: {{ productInfo.tax_sell_1.value }}%
          </div>
          <div class="tax-chip" v-if="productInfo.tax_sell_2.name">
            <span>{{ productInfo.tax_sell_2.name }}</span>: {{ productInfo.tax_sell_2.value }}%
          </div>
          <div class="tax-chip" v-if="productInfo.tax_sell_3.name">
            <span>{{ productInfo.tax_sell_3.name }}</span>: {{ productInfo.tax_sell_3.value }}%
          </div>
        </div>

      </div>
    </div>

    <!-- ERROR -->
    <div class="error-msg mt-1" v-if="productError">
      {{ productError.message }}
    </div>

  </div>
  <!-- / Detail Style 2 -->
  <!-- / Content -->
</template>

<script>
import { mapState } from "vuex";
import { TAX_CONFIG, PRODUCT_UNIT } from "../../config/common.js"
// import VueMultiselect from 'vue-multiselect'
// import { utilities } from "../../services/utilities.js"

export default {
  name: 'ShipmentProductDetail',
  components: {
    // VueMultiselect
  },
  props: {
    "product": {
			type: Object,
			required: true
		},
    "index": {
      type: Number,
			required: true
    },
    "item_view": {
      type: Boolean,
      default: true
    }
  },
  emits :{
    removeOneProduct: null,
    productChanged: null,
    // changeAmountValue: null
  },
  data() {
    return {
      productInfo: this.product,
      key: this.index,
      page: 1,
      productSelected: null,
      cleaveOptions: {
        buy_price: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand'
        },
        sell_price: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand'
        },
        purchase_total_amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        },
        sell_total_amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        },
        quantity_in: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        },
        quantity_out: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        },
        tax: {
          numeral: true,
          numeralDecimalScale: 1
        }
      }
    }
  },
  watch: {
    "productInfo.quantity_in": "onQuantityChange",
    "productInfo.quantity_out": "onQuantityChange",
    "stateData.buy_exchange_rates"(rate) {
      if (!rate) return;

      this.productInfo.buy_price_vnd =
        Number(this.productInfo.buy_price || 0) * Number(rate || 0);

      // this.$store.dispatch('shipmentAdd/reCalculateGrandTotal');
    },

    "stateData.sell_exchange_rates"(rate) {
      if (!rate) return;

      this.productInfo.sell_price_vnd =
        Number(this.productInfo.sell_price || 0) * Number(rate || 0);

      // this.$store.dispatch('shipmentAdd/reCalculateGrandTotal');
    },
  },
  computed: {
    ...mapState({
      stateData: state => state.shipmentAdd.stateData
    }),
    taxOptions() {
      return TAX_CONFIG;
    },
    productUnits() {
      return PRODUCT_UNIT;
    },
    productError() {
      return this.stateData.error_lists.find(
        e => e.product_id === this.productInfo.product_id
      );
    }
  },
  created() {
    // Handling Product Name selected
    for (let i=1; i<=3; i++) {
      if(this.productInfo["tax_buy_name_"+i]) {
        this.productInfo["tax_buy_"+i] = {
          id: i,
          name: this.productInfo["tax_buy_name_"+i],
          value: this.productInfo["tax_buy_value_"+i],
          is_display: true, 
        }
      }
      else {
        this.productInfo["tax_buy_"+i] = {
          id: i,
          name: "",
          value: "",
          is_display: true, 
        }
      }

      if(this.productInfo["tax_sell_name_"+i]) {
        this.productInfo["tax_sell_"+i] = {
          id: i,
          name: this.productInfo["tax_sell_name_"+i],
          value: this.productInfo["tax_sell_value_"+i],
          is_display: true, 
        }
      }
      else {
        this.productInfo["tax_sell_"+i] = {
          id: i,
          name: "",
          value: "",
          is_display: true, 
        }
      }
    }
  }, 
  mounted() {
    this.productInfo.buy_price_vnd = this.productInfo.buy_price * this.stateData.buy_exchange_rates;
    this.productInfo.sell_price_vnd = this.productInfo.sell_price * this.stateData.sell_exchange_rates;
  },
  methods: {
    getProductUnitName(unit) {
      if(unit == undefined) return "";
      let punit = this.productUnits.filter(item => {
        return item.value == unit;
      });
      if(punit.length > 0) {
        return punit[0].name;
      }
      else {
        return "";
      }
    },
    getFormatCurrency(value) {
      return Intl.NumberFormat().format(value);
    },
    onQuantityChange() {
      const qtyIn  = Number(this.productInfo.quantity_in || 0);
      const qtyOut = Number(this.productInfo.quantity_out || 0);

      const qtyInNow = qtyIn + Number(this.productInfo.quantity_in_progressive || 0);
      const qtyOutNow = qtyOut + Number(this.productInfo.quantity_out_progressive || 0);

      this.productInfo.quantity_in_stock = qtyInNow - qtyOutNow;

      // Validate
      let error = null;
      if (qtyOutNow > qtyInNow) {
        error = {
          message:
            "Product quantity of delivery voucher is over the quantity of receiving voucher."
        };
      }

      // Update quantity
      this.$store.commit("shipmentAdd/updateProductQuantity", {
        product_id: this.productInfo.product_id,
        quantity_in: qtyIn,
        quantity_out: qtyOut
      });

      // Update error
      this.$store.commit("shipmentAdd/updateProductError", {
        product_id: this.productInfo.product_id,
        error
      });

      // Emit change signal to parent
      this.$emit("productChanged");
    }
  },
}
</script>

<style>
  .delete-item {
    padding: 0.2rem 0.37rem !important;
  }
  .disabled {
    background-color: #eceef1 !important;
  }
  .edit-input {
    background-color: lightyellow !important;
  }

  /* .shipment-item {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fff;
  } */

  .shipment-row {
    padding: 4px 0;
  }

  .row-label {
    font-size: 13px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
  }

  .input-wrap {
    position: relative;
  }

  .input-unit-left {
    position: absolute;
    left: 8px;
    bottom: 10px;
    font-size: 12px;
    color: #868e96;
    pointer-events: none;
    text-transform: uppercase;
  }
   /* RESET bootstrap input look */
  .form-soft,
  .form-soft:disabled,
  .form-soft[disabled] {
    /* background: transparent !important; */
    border: none !important;
    /* border-bottom: 1px solid #ced4da !important; */
    border-radius: 2px !important;
    box-shadow: none !important;
    padding-left: 34px;
    padding-right: 6px;
    font-size: 0.9375rem;
    color: #495057;
    text-align: right;
  }

  /* Focus effect */
  .form-soft:focus {
    border-bottom: 2px solid #0d6efd !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Disabled look – vẫn rõ nhưng nhẹ */
  .form-soft:disabled {
    color: #6c757d;
    opacity: 1;
    cursor: default;
  }

  .qty-field {
    width: 90px;
    max-width: 90px;
  }

  .tax-chip {
    margin-left: 6px;
    padding: 8px 10px;
    font-size: 12px;
    border-radius: 999px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    color: #495057;
    white-space: nowrap;
  }

  .tax-chip span {
    font-weight: 500;
  }

</style>